export const INPUT_CONTROL_WITH_LABEL_DATA_IDS = {
  base: 'control',
  tooltip: '',
  control: '',
  container: 'container',
  labelContainer: 'labelContainer',
  label: 'label',
  children: 'children'
};
